export const DEFAULT_EYEGLASSES_PACKAGE_INDEX = 1;
export const DEFAULT_SUNGLASSES_PACKAGE_INDEX = 0;

export const LENS_PACKAGE_ICONS = {
    diamond: 'premium',
    gold: 'standard',
    platinum: 'polycarbonate',
    polycarbonate: 'polycarbonate',
    'polycarbonate plus': 'polycarbonate',
    premium: 'premium',
    silver: 'value',
    standard: 'standard',
    super: 'polycarbonate',
    trivex: 'value',
    'trivex plus': 'standard',
    value: 'value',
} as const;

export const SG_LENS_PACKAGE_ICONS = {
    'Index1.5': 'value',
    'Index1.53-HC': 'value',
    'Index1.59-HC': 'polycarbonate',
    'Index1.59-HMX': 'polycarbonate_plus',
    'Thin1.61': 'polycarbonate',
    'Thin1.67': 'super_thin',
} as const;

export const SG_LENS_PACKAGE_TITLE = {
    'Index1.5': 'Value',
    'Index1.53-HC': 'Trivex',
    'Index1.59-HC': 'Polycarbonate',
    'Index1.59-HMX': 'Polycarbonate Plus',
    'Thin1.61': 'Standard',
    'Thin1.67': 'Super',
};

export const EXCLUDE_PACKAGE_FROM_WIZARD_IDS_LIST: Record<string, number[]> = {
    'svregpak-Polycarbonate-Plus-Impact-resistant-index1.59-HMC': [14, 15],
    'svregpak-Super-Thin1.61-HMC': [1, 2],
};

export const BASIC_PACKAGE_DATA = {
    description: '1.5 Index Basic Lenses',
    packageDetails: [
        {
            description:
                'Our standard CR-39 plastic lenses; works best for low prescriptions ranging from -1.75 to +1.75. For higher prescriptions we recommend that you upgrade your lens package.',
            icon: 'Index 1.5',
            notes: '',
            title: '1.5 Index basic lenses',
        },
    ],
    popupDescription: 'All eyeglasses prices include our Basic Lens Package for free, with:',
    popupTitle: 'Basic Lens Package',
    title: 'Basic',
};

export const NOT_AVAILABLE = 'Not available for your prescription';
